<template>
  <!-- CPAP 置き在庫一覧 -->
  <div id="CpapInstrumentList">
    <section>
      <div id="container-center">
        <div class="labelTitle lable">CPAP 預託機器一覧</div>
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>機種</th>
              <td>
                <select>
                <option></option>
                <option>ドリームステーションAuto</option>
                <option>ドリームステーションGo</option>
                <option>ドリームステーションBiPAP Auto</option>
                <option>エスボックス バイスタルク</option>
                <option>プリズマライン(prisma25S)</option>
                </select>
              </td>
              <!--
              <th>種別</th>
              <td><select>
                <option></option>
                <option>置き在庫</option>
                <option>デモ</option>
                <option>試用</option>
              </select></td>
              -->
              <th>シリアル</th>
              <td><input type="text"/></td>
              <th>医療機関名</th>
              <td><input type="text"/></td>
            </tr>
            <tr>
              <th>郵便番号</th>
              <td><input type="text"/></td>
              <th>担当支店</th>
              <td><select/></td>
            </tr>
          </table>
          <div class="searchButton-area">
            <b-button class="is-primary" @click="doSearch">検索</b-button>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area"  v-if="hasResult">
          <div>
            <b-table
              id="requestFormListTable"
              :data="data"
              :paginated="isPaginated"
              per-page="100"
              pagination-position="both"
              default-sort="patientCode"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column field="inspection" label="機器" width="180" sortable>{{props.row.inspection}}</b-table-column>
                <b-table-column field="serial" label="シリアル" width="180" sortable>{{props.row.serial}}</b-table-column>
                <b-table-column field="branchOffice" label="医療機関名" width="180" sortable >{{props.row.hospital}}</b-table-column>
                <b-table-column field="branchOffice" label="担当支店" width="100" sortable>{{props.row.branchOffice}}</b-table-column>
                <b-table-column label="処方開始" width="80" centered>
                  <router-link to="/guest/cpap/CpapRequest" :key="index">
                    <a @click="showDetail(props.row.detailKind, props.row.progress,props.row)">
                      <b-icon icon="clipboard-pulse"/>
                    </a>
                  </router-link>
                </b-table-column>
                <b-table-column label="機器返却" width="80" centered>
                  <a @click="returnInstrument(props.row)">
                    <b-icon icon="cloud-upload"/>
                  </a>
                </b-table-column>
                <!--
                <b-table-column label="申込印刷" width="80" centered>
                  <a @click="printDetail(props.row.detailKind,props.row)">
                  <b-icon icon="printer"/></a>
                </b-table-column>
                <b-table-column label="報告書" width="60" centered  sortable>
                  <template v-if="props.row.detailKind.indexOf('企業検診')==-1 && (props.row.progress==13 || props.row.progress==14 || props.row.progress==15)">
                    <a @click="showReportArea(props.row.reportFileList)"><b-icon icon="clipboard-file-outline" /></a>
                    <span v-if="showDownloadMark(props.row.reportFileList)" class="download"></span>
                  </template>
                </b-table-column>
                <b-table-column label="問い合わせ" width="80" centered>
                  <a :href=props.row.ref>
                    <b-icon icon="email-outline"/></a></b-table-column>
                -->
              </template>
            </b-table>
          </div>
          <div>
            <b-button class="backbutton is-primary" @click="back">戻る</b-button>
          </div>
        </div>
      </div>
      <!--
      <floatingDiv v-if="isShowHstDetail" @close="closeDetail" title="" width="640px" height="480px" :top="dialogTopPostion" right="100px">
        <hstRequestDetail :data="showDetailTargetData"/>
      </floatingDiv>
      -->
    </section>
  </div>
</template>
<script>
const sampleData = require('@/sampledata/CpapPatientList.json');

import {role} from "@/components/mock/base/const.js";
import {choicesType} from "@/components/mock/base/const.js";
import {service} from "@/components/mock/base/const.js";
import {requestStatus} from "@/components/mock/base/const.js";
import floatingDiv from "@/components/mock/common/FloatingDiv";
//import CpapRequestDetail from "@/components/mock/common/CpapRequestDetail";

export default {
  name: "CpapInstrumentList",
  methods: {
    back: function() {
      this.$router.go(-1);
    },
    reSearch: function() {
      this.reSearchFlag = true
      this.doSearch()
    },
    doSearch: function() {
      this.hasResult = true;
    },
    showDetail: function(kind, progress, rowData) {
      if (isHospital || isDealer) {
        this.$router.push({ path: "/guest/cpap/CpapRequest" });
      }
      else {
        this.$router.push({ path: "/guest/cpap/CpapAgentRequest" });
      }
    },
    returnInstrument: function(rowData) {
      if(rowData) {
        var inspection = rowData.inspection;
        var serial = rowData.serial;
        var messsage = inspection + "（" + serial + "）を返却します。機種が正しいことを確認して「OK」ボタンを押してください。<br/><span style=\"font-size: 14px;\">※申込み後のキャンセルは申請一覧の受付番号の右端のメールボタンから問い合わせをお願いします。機器が出荷された後のキャンセルは不可となり、請求が発生しますのでご注意ください</span>"
        this.$dialog.confirm({
          title: "申込み確認",
          message: messsage,
          cancelText: "Cancel",
          onConfirm: async () => {}
        });
      }
    }
  },
  data() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId = userInfo.roleId;
    var isHospital = roleId == role.role_hospital;
    var isDealer = roleId == role.role_dealer;
    var isSalesOffice = roleId == role.role_salesOffice;
    var isHonsha = roleId == role.role_headOffice;
    var isAdmin = roleId == role.role_admin;
    //let kindList = this.getKindGroup();
    let kindList = this.getChoiceList(choicesType.cpapKind);
    return {
      data: sampleData,
      role: role,
      isHospital: isHospital,
      isDealer: isDealer,
      isSalesOffice: isSalesOffice,
      isHonsha: isHonsha,
      isAdmin: isAdmin,
      kindList,
      isPaginated : true,
      hasResult: false
    };
  },
  filters: {},
  components: { 
    floatingDiv: floatingDiv,
  },
  async mounted() {
  }
};
</script>
<style lang="scss" scoped>
.conditionTable th {
  width: 100px;
}
.conditionTable td {
  width: 400px;
}
a {
  text-decoration: underline;
}
.tag {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/cpap/CpapInstrumentList.vue